module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breadcrumbs_wrap"
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_c('i', {
    staticClass: "material-icons element-icon"
  }, [_vm._v("edit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/editor/' + _vm.adventureId
    }
  }, [_vm._v(_vm._s(_vm.textTools.parseTitle(_vm.adventure.name, "Adventure")))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), (_vm.chapterId) ? _c('i', {
    staticClass: "material-icons element-icon"
  }, [_vm._v("collections_bookmark")]) : _vm._e(), _vm._v(" "), (_vm.chapterId) ? _c('router-link', {
    attrs: {
      "to": '/editor/' + _vm.adventureId + '/chapters/' + _vm.chapterId
    }
  }, [_vm._v(_vm._s(_vm.textTools.parseTitle(_vm.chapter.name, "Chapter")))]) : _vm._e(), _vm._v(" "), (_vm.stageId) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_right")]) : _vm._e(), _vm._v(" "), (_vm.stageId) ? _c('i', {
    staticClass: "material-icons element-icon"
  }, [_vm._v("nature_people")]) : _vm._e(), _vm._v(" "), (_vm.stageId) ? _c('router-link', {
    attrs: {
      "to": '/editor/' + _vm.adventureId + '/chapters/' + _vm.chapterId + '/stages/' + _vm.stageId
    }
  }, [_vm._v(_vm._s(_vm.textTools.parseTitle(_vm.stage.name, "Stage")))]) : _vm._e(), _vm._v(" "), (_vm.objectId) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_right")]) : _vm._e(), _vm._v(" "), (_vm.objectId) ? _c('i', {
    staticClass: "material-icons element-icon"
  }, [_vm._v("widgets")]) : _vm._e(), _vm._v(" "), (_vm.objectId) ? _c('router-link', {
    attrs: {
      "to": '/editor/' + _vm.adventureId + '/chapters/' + _vm.chapterId + '/objects/' + _vm.objectId
    }
  }, [_vm._v(_vm._s(_vm.textTools.parseTitle(_vm.object.name, "Object")))]) : _vm._e(), _vm._v(" "), (_vm.timelineLocation) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_right")]) : _vm._e(), _vm._v(" "), (_vm.timelineLocation) ? _c('i', {
    staticClass: "material-icons element-icon"
  }, [_vm._v("device_hub")]) : _vm._e(), _vm._v(" "), (_vm.timelineLocation) ? _c('router-link', {
    attrs: {
      "to": '/editor/' + _vm.adventureId + '/chapters/' + _vm.chapterId + '/timeline'
    }
  }, [_vm._v("Timeline")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fa1547c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumbs.vue
// module id = 304
// module chunks = 0